import { render, staticRenderFns } from "./row.vue?vue&type=template&id=11612ef8&"
import script from "./row.vue?vue&type=script&lang=ts&"
export * from "./row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports